module.exports = __webpack_public_path__ + "images/the Gwillest.png";